import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createClient } from "@supabase/supabase-js";
import "../Login/Login.css";
import logo from "../../assets/dr-is-in.png";

const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  "https://zvacumxidqqaueuruwnj.supabase.co";

const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp2YWN1bXhpZHFxYXVldXJ1d25qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1NTk4ODQsImV4cCI6MjA5NDEzNTg4NH0.PkuVH1cMeGpG5GTckXBNuSdvWFwUij27s25M1MkKYgQ";

const supabase = createClient(supabaseUrl, supabaseAnonKey);

function clean(v: any) {
  return String(v ?? "").trim();
}

export default function ContactUsGeneral() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [body, setBody] = useState("");
  const [direct, setDirect] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState<{ kind: "ok" | "err"; text: string } | null>(null);

  const canSubmit = useMemo(() => {
    const n = clean(name);
    const b = clean(body);

    if (!n || b.length < 10) return false;

    if (direct) {
      const e = clean(email);
      const p = clean(phone);
      if (!e && !p) return false;
    }

    return true;
  }, [name, body, direct, email, phone]);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setMsg(null);
    setSubmitting(true);

    try {
      const contactMessage = [
        `Name: ${clean(name)}`,
        `Email: ${clean(email) || "Not provided"}`,
        `Phone: ${clean(phone) || "Not provided"}`,
        `Direct feedback requested: ${direct ? "Yes" : "No"}`,
        "",
        clean(body),
      ].join("\n");

      const { error } = await supabase.from("contacts").insert({
        contact_type: "general",
        message: contactMessage,
        created_by: clean(name) || clean(email) || "public_user",
      });

      if (error) throw error;

      setMsg({ kind: "ok", text: "Thanks — your message was sent." });

      setName("");
      setEmail("");
      setPhone("");
      setBody("");
      setDirect(false);

      setTimeout(() => navigate("/contact-us"), 700);
    } catch (err: any) {
      setMsg({ kind: "err", text: err?.message || "Submit failed." });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logo} alt="Doctor Is In Logo" className="login-logo" />
        <h2 className="login-title">General Information</h2>

        {msg && (
          <div
            style={{
              width: "100%",
              margin: "10px 0",
              padding: "10px 12px",
              borderRadius: 10,
              fontSize: 13,
              border: "1px solid rgba(0,0,0,0.12)",
              background: msg.kind === "ok" ? "rgba(0,0,0,0.04)" : "rgba(255,0,0,0.10)",
              color: "#111",
              textAlign: "center",
            }}
          >
            {msg.text}
          </div>
        )}

        <form onSubmit={submit} className="login-actions">
          <input
            className="login-input"
            placeholder="Name (required)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            disabled={submitting}
          />

          <input
            className="login-input"
            placeholder="Email (optional)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={submitting}
          />

          <input
            className="login-input"
            placeholder="Phone (optional)"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            disabled={submitting}
          />

          <textarea
            className="login-input"
            placeholder="Tell Us How We Can Help You (required)"
            value={body}
            onChange={(e) => setBody(e.target.value)}
            rows={5}
            required
            disabled={submitting}
          />

          <label style={{ display: "flex", gap: 8, alignItems: "center", justifyContent: "center" }}>
            <input
              type="checkbox"
              checked={direct}
              onChange={(e) => setDirect(e.target.checked)}
              disabled={submitting}
            />
            <span style={{ fontSize: 12 }}>Direct feedback (email or phone required)</span>
          </label>

          <button type="submit" className="login-btn" disabled={submitting || !canSubmit}>
            {submitting ? "Submitting..." : "Submit"}
          </button>

          <button type="button" className="login-btn" onClick={() => navigate("/contact-us")} disabled={submitting}>
            ← Back
          </button>
        </form>

        <div className="login-footer">© {year} Doctor Is In App. All rights reserved.</div>
      </div>
    </div>
  );
}